/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateActivityRequest,
  ListActivities200Response,
  ShowActivity200Response,
  UpdateActivityRequest,
} from '../models/index';
import {
    CreateActivityRequestFromJSON,
    CreateActivityRequestToJSON,
    ListActivities200ResponseFromJSON,
    ListActivities200ResponseToJSON,
    ShowActivity200ResponseFromJSON,
    ShowActivity200ResponseToJSON,
    UpdateActivityRequestFromJSON,
    UpdateActivityRequestToJSON,
} from '../models/index';

export interface CreateActivityOperationRequest {
    createActivityRequest: CreateActivityRequest;
}

export interface DeleteActivityRequest {
    id: number;
}

export interface ShowActivityRequest {
    id: number;
}

export interface UpdateActivityOperationRequest {
    id: number;
    updateActivityRequest?: UpdateActivityRequest;
}

/**
 * ActivitiesApi - interface
 * 
 * @export
 * @interface ActivitiesApiInterface
 */
export interface ActivitiesApiInterface {
    /**
     * 
     * @summary Create activity
     * @param {CreateActivityRequest} createActivityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    createActivityRaw(requestParameters: CreateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Create activity
     */
    createActivity(requestParameters: CreateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete activity
     * @param {number} id The ID of the activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    deleteActivityRaw(requestParameters: DeleteActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Delete activity
     */
    deleteActivity(requestParameters: DeleteActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary List activities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    listActivitiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListActivities200Response>>;

    /**
     * 
     * List activities
     */
    listActivities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListActivities200Response>;

    /**
     * 
     * @summary Show activity
     * @param {number} id The ID of the activity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    showActivityRaw(requestParameters: ShowActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowActivity200Response>>;

    /**
     * 
     * Show activity
     */
    showActivity(requestParameters: ShowActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowActivity200Response>;

    /**
     * 
     * @summary Update activity
     * @param {number} id The ID of the activity.
     * @param {UpdateActivityRequest} [updateActivityRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApiInterface
     */
    updateActivityRaw(requestParameters: UpdateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Update activity
     */
    updateActivity(requestParameters: UpdateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ActivitiesApi extends runtime.BaseAPI implements ActivitiesApiInterface {

    /**
     * 
     * Create activity
     */
    async createActivityRaw(requestParameters: CreateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createActivityRequest'] == null) {
            throw new runtime.RequiredError(
                'createActivityRequest',
                'Required parameter "createActivityRequest" was null or undefined when calling createActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/activities`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateActivityRequestToJSON(requestParameters['createActivityRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Create activity
     */
    async createActivity(requestParameters: CreateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createActivityRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Delete activity
     */
    async deleteActivityRaw(requestParameters: DeleteActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/activities/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Delete activity
     */
    async deleteActivity(requestParameters: DeleteActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteActivityRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * List activities
     */
    async listActivitiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListActivities200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/activities`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListActivities200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * List activities
     */
    async listActivities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListActivities200Response> {
        const response = await this.listActivitiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * Show activity
     */
    async showActivityRaw(requestParameters: ShowActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowActivity200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/activities/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowActivity200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Show activity
     */
    async showActivity(requestParameters: ShowActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowActivity200Response> {
        const response = await this.showActivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Update activity
     */
    async updateActivityRaw(requestParameters: UpdateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/activities/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateActivityRequestToJSON(requestParameters['updateActivityRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Update activity
     */
    async updateActivity(requestParameters: UpdateActivityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateActivityRaw(requestParameters, initOverrides);
    }

}
